/**
 * Панель «Отделка» в левой выдвижной панели: каталог отделки стен и пола с картинками.
 *
 * Слева только каталог — узкой колонкой, чтобы не закрывать сцену. Что выделено и его
 * настройки — в плашке внизу рядом с каталогом (`FinishTargetBar`); на телефоне панель
 * открывается окном, и там эта плашка стоит над каталогом. Справа отделки нет.
 *
 * Каталог — того, по чему кликнули (`useFinishSurface`): стена — `WallFinishPanel` (краска,
 * обои, плитка, штукатурка, панели), пол — `FloorFinishPanel` (плитка, ламинат, кварцвинил,
 * линолеум), мягкая мебель — `FabricPanel` (ткани и кожа обивки). Обои на пол не попадут
 * и доска на стену тоже.
 */
import { useFinishSurface } from "../hooks/useFinishSurface";
import { FabricPanel } from "./FabricPanel";
import { FloorFinishPanel } from "./FloorFinishPanel";
import { WallFinishPanel } from "./WallFinishPanel";

export const FinishCatalogDrawer = () => {
	const surface = useFinishSurface();
	return (
		<div className="flex h-full min-h-0 flex-col overflow-hidden">
			{surface === "walls" && <WallFinishPanel />}
			{surface === "floor" && <FloorFinishPanel />}
			{surface === "furniture" && <FabricPanel />}
		</div>
	);
};
